import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

export default class ModalDeleteSurvey extends Component {
    constructor(props) {
        super(props);

        this.state = {
            surveyModal: null,
            loading: false
        }

        this.deleteOrActiveSurvey = this.deleteOrActiveSurvey.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            surveyModal : props.surveyModal
        })
    }

    deleteOrActiveSurvey() {
        this.setState({
            loading: true
        });

        axios.post(global.config.apiDomain + '/rest/survey/deleteOrActiveSurvey', this.state.surveyModal)
        .then(res => {
            this.setState({
                loading: false
            });

            if (res.data.status == "OK") {
                window.$("#modalDeleteSurvey").modal("hide");
                toast.success(res.data.message); 
                this.props.resetList();
            } else {
                toast.warning(res.data.message);
            }
        })
    }

    render() {
        const {surveyModal} = this.state;

        return (
            <div>
                <div className="modal fade" id="modalDeleteSurvey" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            {(surveyModal && !surveyModal.deleted) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">Ẩn Khảo sát</h5>
                            ) : ""}
                            {(surveyModal && surveyModal.deleted) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">HIỆN Khảo sát</h5>
                            ) : ""}
                               
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {(surveyModal && !surveyModal.deleted) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">Bạn chắc chắn muốn Ẩn Khảo sát: <span className="font-weight-bold">Level {surveyModal._id}</span> ?</h3>
                            </div>
                            ) : ""}
                            {(surveyModal && surveyModal.deleted) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-info">Bạn muốn HIỆN Khảo sát: <span className="font-weight-bold">Level {surveyModal._id}</span> ?</h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.deleteOrActiveSurvey}>Xác nhận</button>    
                                )}                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}